import {Component, OnInit} from '@angular/core';
import {
  LighthouseBrandListDisplayItem, LighthouseEndpointListDisplayItem,
  LighthousePortalListDisplayItem, StateNamePipe
} from '@shared-library';
import {ConfigService} from '@shared-library';
import {Router} from '@angular/router';
import {NGXLogger} from 'ngx-logger';
import {CommonModule} from "@angular/common";
import {
  FdkCardComponent,
  FdkLinkComponent,
  FdkIconComponent,
} from 'fasten-design-kit';

@Component({
    selector: 'app-health-system-brand-details',
    templateUrl: './health-system-brand-details.component.html',
    styleUrls: ['./health-system-brand-details.component.css'],
    standalone: true,
    imports: [
      CommonModule,
      StateNamePipe,
      FdkLinkComponent,
      FdkCardComponent,
      FdkIconComponent
    ]
})
export class HealthSystemBrandDetailsComponent implements OnInit {
  private failedLogoBrandId?: string;

  constructor(
    public configService: ConfigService,
    public router: Router,
    private logger: NGXLogger,
  ) {}

  ngOnInit(): void {
  }

  shouldShowBrandLogo(brandId?: string): boolean {
    return !!brandId && brandId !== this.failedLogoBrandId
  }

  handleBrandLogoError(): void {
    this.failedLogoBrandId = this.configService.searchConfig$?.selectedBrand?.id
  }

  getBrandInitials(name: string): string {
    const words = name.trim().split(/\s+/).filter(Boolean)

    if (words.length > 1) {
      return `${words[0][0]}${words[1][0]}`
    }

    return words[0]?.slice(0, 2) || ''
  }

  addPendingAccount(brand: LighthouseBrandListDisplayItem, portal: LighthousePortalListDisplayItem, endpoint: LighthouseEndpointListDisplayItem){
    this.logger.debug("addPendingAccount", brand, portal, endpoint)

    this.configService.vaultProfileAddPendingAccount(brand, portal, endpoint)
    this.router.navigateByUrl('dashboard', {replaceUrl: true})
  }
}
